@if (!showContainer) {
  <section class="scan-order-container">
    <header class="header">
      <div class="row">
        <div class="header__title" mat-dialog-title>
          <span class="header_title-elements">
            <span class="header_title-element" id="order-number"
              ><span>Order # {{ order.orderNumber }} </span>
              @if (order.splitted) {
                <span>-{{ orderSplitIndicesText }}</span>
              }
            </span>
            <span class="header_title-element">
              <app-orders-count-chip [size]="2" [row]="order"></app-orders-count-chip>
            </span>
          </span>
          <span class="header__display-box">
            @if (order?.orderRiskLevel) {
              <span>
                @if (order?.orderRiskLevel === 'High') {
                  <img
                    style="margin-top: 3px; margin-left: 2px"
                    [ngStyle]="{ opacity: '.1' }"
                    src="../assets/icons/High-fraud.svg"
                    [matTooltip]="'High Fraud  &#13;  (Approved As Safe)'"
                    matTooltipClass="pdq-mat-tooltip" />
                }
                @if (order?.orderRiskLevel === 'Medium') {
                  <img
                    style="margin-top: 3px; margin-left: 2px"
                    [ngStyle]="{ opacity: '.1' }"
                    src="../assets/icons/Medium-fraud.svg"
                    [matTooltip]="'Medium Fraud &#13; (Approved As Safe)'"
                    matTooltipClass="pdq-mat-tooltip" />
                }
              </span>
            }
          </span>
          <span class="header__display-box">
            @if (order['orderStatus']?.includes('pendingApproved')) {
              <span>
                <img
                  style="margin-top: 3px; margin-left: 2px"
                  [ngStyle]="{ opacity: '.1' }"
                  src="/assets/icons/not-paid-Icon.svg"
                  [matTooltip]="'Payment was Approved Manually'"
                  matTooltipClass="pdq-mat-tooltip" />
              </span>
            }
          </span>
          <span role="button" class="close-btn">
            <img mat-dialog-close src="/assets/images/scan/close_icon.svg" alt="" />
          </span>
        </div>
      </div>
      <mat-divider class="customer-details__divider" style="padding-bottom: 30px"></mat-divider>
    </header>
    <div class="scan-order-content" mat-dialog-content>
      <div class="customer-details">
        <app-scan-input-for-order-modal [modalType]="'sku'"> </app-scan-input-for-order-modal>
        <mat-divider class="customer-details__divider"></mat-divider>
        <div class="customer-details__title">Customer details:</div>
        <div>
          {{ order.pickUpLocationId ? order.billingName : order.shippingFirstName }}
          {{
            order.pickUpLocationId
              ? ''
              : order.shippingLastName
                ? order.shippingLastName
                : !order.shippingFirstName
                  ? order.shippingName
                  : ''
          }}
        </div>
        <div>
          {{ order.shippingAddress?.address1 || (order.pickUpLocationId ? order.billingPhone : '') }}
          &nbsp;
          {{ order.shippingAddress?.address2 }}
        </div>
        <div>
          {{ order.shippingAddress?.city }}{{ order.shippingAddress ? ', ' : '' }}{{ order.shippingAddress?.country }}
        </div>
        <div>
          {{ order.shippingAddress?.zip || (order.pickUpLocationId ? order.email : '') }}
        </div>
        @if (order.customer?.group1 || order.customer?.group2 || checkIfShouldDisplayOrdersCountChip(order)) {
          <div class="customer-details__customer-groups">
            <app-orders-count-chip [size]="2" [row]="order"></app-orders-count-chip>
            @if (order.customer?.group1) {
              <span class="customer-details__customer-group">
                {{ order.customer.group1 }}
              </span>
            }
            @if (order.customer?.group2) {
              <span class="customer-details__customer-group">
                {{ order.customer.group2 }}
              </span>
            }
          </div>
        }
        <div>
          <button class="print-btn" [disabled]="isTplCarrier" (click)="openbulktoprint(order.id)">
            <img
              class="customer-details__print"
              [ngStyle]="{ opacity: !isTplCarrier ? 1 : 0.2 }"
              src="../../../../../assets/images/print/print_icon.svg" />
          </button>
        </div>
        <mat-divider class="customer-details__divider"></mat-divider>
        <span fxLayout="column" fxLayoutAlign="center center" style="width: min-content">
          @if (order.orderBatch.selectedCarrier.name) {
            <div>
              <carrier-logo [carrierName]="order.orderBatch?.selectedCarrier?.type?.name"></carrier-logo>
            </div>
          }
          @if (order.orderBatch?.serviceLevel?.type) {
            <div class="carrier-type-text">
              {{ getCarrierServiceLevelFormattedString(order.orderBatch?.serviceLevel?.type) }}
            </div>
          }
        </span>
        <p class="customer-details__note-font">{{ order.deliveryMethod }}</p>
        <mat-divider class="customer-details__divider"></mat-divider>
        <div class="customer-details__note">
          Notes
          <img mat-dialog-close src="/assets/icons/notes-customer.png" alt="" style="padding-left: 5px" />
        </div>
        @if (order.note === '') {
          <p class="customer-details__note-font">There is no note on this order.</p>
        }
        <p class="customer-details__note-font">{{ order.note }}</p>
      </div>
      <div class="order-items order-items__scroll" fxFlex>
        <button
          class="order-items__fulfill-all-button"
          [disabled]="isTplCarrier"
          (click)="updateAllItemScannedQuantity()">
          Fulfill All Items
        </button>
        <div class="order-items__title">Items:</div>
        @for (orderItem of order.orderItems; track orderItem) {
          <div
            class="order-item"
            [ngClass]="{
              'order-item--partial':
                orderItem.fulfillableQuantity >= 1 && orderItem.fulfillableQuantity < orderItem.quantity,
              'order-item--fulfilled': orderItem.fulfillableQuantity === 0 || isTplCarrier,
            }">
            <div class="order-item__image">
              <img [src]="orderItem.variant?.image || orderItem.product.image || defaultImage" alt="" />
            </div>
            <div class="order-item__info">
              <div>{{ orderItem.product.name }}</div>
              <!--          <div>{{ orderItem.externalId }}</div>-->
              <div>{{ orderItem.variant?.title }}</div>
              <div>{{ orderItem.sku || '' }}</div>
              <div>
                {{ orderItem.fulfillableQuantity === null ? 0 : orderItem.quantity - orderItem.fulfillableQuantity }}
                /
                {{ orderItem.quantity }}
              </div>
            </div>
            <button
              role="button"
              class="order-item__status"
              [ngClass]="isTplCarrier ? 'order-item__tpl' : ''"
              [disabled]="isTplCarrier"
              (click)="updateItemScannedQuantity(orderItem?.sku, orderItem.externalId)">
              <img src="/assets/images/scan/check_icon.svg" alt="" style="margin-right: 5px" />
            </button>
          </div>
        }
      </div>
    </div>
    <div class="scan-order-actions" mat-dialog-actions>
      <!--    <button-->
      <!--      class="scan-order-actions__btn scan-order-actions__btn&#45;&#45;scan"-->
      <!--      mat-flat-button-->
      <!--      color="primary"-->
      <!--      (click)="openScanSkuDialog()"-->
      <!--    >-->
      <!--      SCAN MANUALLY-->
      <!--    </button>-->
      <button
        class="scan-order-actions__btn scan-order-actions__btn--fulfill"
        mat-flat-button
        color="primary"
        (click)="fulfillOrder()"
        [disabled]="fulfillItemsPayload.length < 1 || isTplCarrier">
        @if (loader) {
          <mat-spinner [diameter]="30" class="fulfill-spinner"></mat-spinner>
        }
        @if (!loader) {
          FULFILL & CLOSE
        }
      </button>
    </div>
  </section>
} @else {
  <section class="mobile-scan-container">
    <div class="scan-mobile-content">
      <div class="order-items__title">
        <span role="button">
          <img mat-dialog-close src="/assets/icons/back.svg" alt="" class="order-items__title__backImg" />
        </span>
        Order # {{ order.orderNumber }}
        <span role="button">
          <img
            src="/assets/icons/info.svg"
            alt=""
            class="order-items__title__infoImg"
            (click)="openMobileDetails(order)" />
        </span>
      </div>
      <div class="subtitle">Or you can insert barcode/SKU number</div>
      <app-scan-input-for-order-modal [modalType]="'sku'" [showContainer]="showContainer">
      </app-scan-input-for-order-modal>
      <mat-divider class="customer-details__divider" style="margin-bottom: 15px"></mat-divider>
      <div class="order-items">
        @for (orderItem of order.orderItems; track orderItem) {
          <div
            class="order-item"
            [ngClass]="{
              'order-item--partial':
                orderItem.fulfillableQuantity >= 1 && orderItem.fulfillableQuantity < orderItem.quantity,
              'order-item--fulfilled': orderItem.fulfillableQuantity === 0,
            }">
            <div class="order-item__image">
              <img [src]="orderItem.variant?.image || orderItem.product.image || defaultImage" alt="" />
            </div>
            <div class="order-item__info">
              <div>{{ orderItem.product.name }}</div>
              <div>{{ orderItem.sku || '' }}</div>
              <div>
                {{ orderItem.fulfillableQuantity === null ? 0 : orderItem.quantity - orderItem.fulfillableQuantity }}
                /
                {{ orderItem.quantity }}
              </div>
            </div>
            <button
              role="button"
              class="order-item__status"
              [disabled]="isTplCarrier"
              (click)="updateItemScannedQuantity(orderItem?.sku, orderItem.externalId)">
              <img src="/assets/images/scan/check_icon.svg" alt="" style="margin-right: 5px" />
            </button>
          </div>
        }
      </div>
    </div>
    <div class="mobile-actions">
      <button
        class="mobile-actions__btn mobile-actions__btn--fulfill"
        mat-flat-button
        color="primary"
        (click)="fulfillOrder()"
        [disabled]="fulfillItemsPayload.length < 1 || isTplCarrier">
        @if (loader) {
          <mat-spinner [diameter]="30" class="fulfill-spinner"></mat-spinner>
        }
        @if (!loader) {
          FULFILL & CLOSE
        }
      </button>
      <button
        [disabled]="isTplCarrier"
        class="mobile-actions__fulfill-all-button"
        (click)="updateAllItemScannedQuantity()">
        Fulfill All Items
      </button>
    </div>
  </section>
}
